export default __webpack_public_path__ + "monitorIcon.png";